import { useTranslation } from "react-i18next";
import PageWrapper from "../PageWrapper/PageWrapper";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import GeneralSegment from "./sections/GeneralSegment";
import PartnersSegment from "./sections/PartnersSegment";
import AccountsSegment from "./sections/AccountsSegment";
import Tab from "../../components/Tab/Tab";
import AlertsSegment from "./sections/AlertsSegment";
import { AdminRestricted } from "../../components/AdminRestricted/AdminRestricted";
import NotificationsSegment from "./sections/NotificationsSegment";
import PaymentSegment from "./sections/PaymentSegment";
import ModulesSegment from "./sections/ModulesSegment";

type AvailableSections = 'general' | 'accounts' | 'external-partners' | 'alerts' | 'notifications' | 'payments' | 'modules';

function SettingsPage() {

  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState<AvailableSections>('general');

  const activeSegment = useMemo(() => {
    switch(activeSection) {
      case 'external-partners':
        return <PartnersSegment />;
      case 'accounts':
        return <AccountsSegment />;
      case 'payments':
        return <PaymentSegment />;
      case 'modules':
        return <ModulesSegment />;
      case 'general':
        return <GeneralSegment />;
      case 'alerts':
        return <AlertsSegment />;
      case 'notifications':
        return <NotificationsSegment />;
      default:
        return null;
    }
  }, [activeSection]);

  useEffect(() => {
    const tab = searchParams.get("activeTab");
    if (!!tab) {
      setActiveSection(tab as AvailableSections);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWrapper>
      <AdminRestricted>
        <>
          <div className="flex overflow-x-scroll w-full">
            <Tab fn={() => setActiveSection('general')} label={t("settings.menu.general")} isActive={activeSection === 'general'}/>
            <Tab fn={() => setActiveSection('payments')} label={t("settings.menu.payments")} isActive={activeSection === 'payments'}/>
            <Tab fn={() => setActiveSection('modules')} label={t("settings.menu.modules")} isActive={activeSection === 'modules'}/>
            <Tab fn={() => setActiveSection('accounts')} label={t("settings.menu.accounts")} isActive={activeSection === 'accounts'}/>
            <Tab fn={() => setActiveSection('alerts')} label={t("settings.menu.alerts")} isActive={activeSection === 'alerts'}/>
            <Tab fn={() => setActiveSection('notifications')} label={t("settings.menu.notifications")} isActive={activeSection === 'notifications'}/>
            {/* <Tab isDisabled fn={() => setActiveSection('external-partners')} label={t("settings.menu.partners")} isActive={activeSection === 'external-partners'}/> */}
          </div>
          { activeSegment }
        </>
      </AdminRestricted>
    </PageWrapper>
  );
}

export default SettingsPage;
